import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGame } from '../context/GameContext';
import { GamePhase } from '../types';

const PHASE_ROUTES: Record<GamePhase, string> = {
  landing: '/',
  registration: '/registro',
  trivia: '/trivia',
  result: '/resultado',
};

const PHASE_ORDER: GamePhase[] = ['landing', 'registration', 'trivia', 'result'];

interface RouteGuardProps {
  requiredPhase: GamePhase;
  children: React.ReactNode;
}

const RouteGuard: React.FC<RouteGuardProps> = ({ requiredPhase, children }) => {
  const { currentPhase } = useGame();
  const navigate = useNavigate();

  const currentIndex = PHASE_ORDER.indexOf(currentPhase);
  const requiredIndex = PHASE_ORDER.indexOf(requiredPhase);

  useEffect(() => {
    if (currentIndex < requiredIndex) {
      navigate(PHASE_ROUTES[currentPhase], { replace: true });
    }
  }, [currentPhase, requiredPhase, navigate, currentIndex, requiredIndex]);

  if (currentIndex < requiredIndex) return null;

  return <>{children}</>;
};

export default RouteGuard;
